import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { ConfiguracionesService } from './../../../services/configuraciones.service';
import { AlertasModales } from '../../../helpers/alertasModales';
@Component({
  selector: 'app-compania',
  templateUrl: './compania.component.html',
  styleUrls: ['./compania.component.css']
})
export class CompaniaComponent implements OnInit {
  form: FormGroup;
  loading = false;
  constructor(private empleadoService: EmpleadosServicio, private configuracionesService: ConfiguracionesService,
    private modals: AlertasModales) {
    this.initForm();
  }

  ngOnInit() {
  }

  private initForm(): void {
    this.form = new FormGroup({
      ID_EMPLEADO: new FormControl(this.empleadoService.datosEmpleado.ID_EMPLEADO, Validators.required),
      limite_velocidad: new FormControl('0', Validators.required),
      minimo_referencias: new FormControl('0', Validators.required),
      limite_prestamos: new FormControl('1', Validators.required),
      mostrar_cedula: new FormControl(false),
      foto_cedula_requerido: new FormControl(false),
      firma_digital: new FormControl(false),
      cobrador_gasto_movil: new FormControl(false),
    });

    this.initConfiguracion();
  }

  private initConfiguracion() {
    this.configuracionesService.obtenerConfiguraciones()
    .subscribe((res: any) => {
      this.form.get('limite_velocidad').setValue(res.limite_velocidad);
      this.form.get('minimo_referencias').setValue(res.minimo_referencias);
      this.form.get('limite_prestamos').setValue(res.limite_prestamos);
      this.form.get('mostrar_cedula').setValue(res.mostrar_cedula);
      this.form.get('foto_cedula_requerido').setValue(res.foto_cedula_requerido);
      this.form.get('firma_digital').setValue(res.firma_digital);
      this.form.get('cobrador_gasto_movil').setValue(res.cobrador_gasto_movil);
    });
  }

  actualizarConfiguracion() {
    if (this.form.valid) {
      this.loading = true;
      this.configuracionesService.configurarOtrasConfiguraciones(this.form.value)
      .subscribe(res => {
        setTimeout(() => this.loading = false, 1);
        if (res) {
          this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-gear');
        }
      }, err => {
        setTimeout(() => this.loading = false, 1);
        if (err) {
          if ((err.hasOwnProperty('status') && err.status === 0) ||
          (err.hasOwnProperty('name') && err.name === 'TimeoutError')) {
            this.modals.validacionesModalJquery('Error al comunicarse con el servidor. Favor de verificar su conexión a internet', '',
              'orange',
              'modern',
              false,
              'fa fa-wifi');
          } else {
            this.modals.validacionesModalJquery('Ha ocurrido un error inesperado', err, 'red', 'modern');
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/configuraciones/compania/compania.component.ts